import { createAction, Action } from 'redux-actions';

export const actionTypes = {
  CLEAR_CURRENT_PATIENT: 'CLEAR_CURRENT_PATIENT',
  SELECT_CURRENT_PATIENT: 'SELECT_CURRENT_PATIENT',
  GET_PATIENT_DETAIL_SUCCESS: 'GET_PATIENT_DETAIL_SUCCESS',
};

export const clearCurrentPatient: () => Action<void> = createAction(
  actionTypes.CLEAR_CURRENT_PATIENT,
);

export const getPatientDetailSuccess = createAction(
  actionTypes.GET_PATIENT_DETAIL_SUCCESS,
);

export const updateCurrentPatient: (
  patientId: string,
) => Action<{ id: string }> = createAction(
  actionTypes.SELECT_CURRENT_PATIENT,
  (patientId: string): { id: string } => ({ id: patientId }),
);
